import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=fc37bb80&scoped=true"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"
import style0 from "./RuleItem.vue?vue&type=style&index=0&id=fc37bb80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc37bb80",
  null
  
)

export default component.exports